export interface Testimonial {
  name: string
  role: string
  location: string
  age: number
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Darren Whitfield',
    role: 'Motorcycle Technician, independent workshop',
    location: 'Leeds, United Kingdom',
    age: 41,
    quote:
      'I have been turning spanners on bikes for eighteen years and my problem was never knowledge, it was time. Every intermittent electrical fault used to mean three tabs open and a pile of printed diagrams on the bench. Now I open the symptom, follow the testing order and stay on the same path until the fault shows itself. Last week a charging complaint that normally eats half a day was confirmed at the regulator in under forty minutes.',
  },
  {
    name: 'Marcus Delaney',
    role: 'Lead Mechanic, multi-brand service centre',
    location: 'Calgary, Canada',
    age: 36,
    quote:
      'What sold me was the no-start workflow. I handed it to my second-year tech and he worked through cranking voltage, ground return and starter condition in the right order instead of guessing at the relay. That alone stopped two unnecessary parts orders in the first month. The electrical testing sections are exactly how I would teach it, just organized better than I ever wrote it down.',
  },
  {
    name: 'Ray Sandoval',
    role: 'Owner, motorcycle repair shop',
    location: 'Phoenix, Arizona, United States',
    age: 49,
    quote:
      'Diagnostics is where my shop was bleeding hours. I was quoting diagnostic time and then eating double because the path was never structured. Using the fault-finding workflows I can tell a customer what will be tested and in what order, and my comeback rate on electrical jobs has dropped noticeably. It reads like a reference a working tech built, not a textbook.',
  },
  {
    name: 'Tom Brennan',
    role: 'Motorcycle Technician, dealership',
    location: 'Brisbane, Australia',
    age: 31,
    quote:
      'The DTC and sensor handbook changed how I handle codes. I used to trust the code and end up replacing a sensor that was fine. Now I check the reference voltage, the ground and the circuit before I condemn anything, and I have caught two wiring faults that would have gone out as sensor replacements. The intermittent fault playbook is worth the price on its own.',
  },
  {
    name: 'Neil Hargreaves',
    role: 'Workshop Foreman, fleet and courier bikes',
    location: 'Manchester, United Kingdom',
    age: 54,
    quote:
      'I run four bays and the biggest win has been consistency. Everyone now follows the same checklist for no-starts, misfires and battery drains, so handovers between shifts actually make sense and nothing gets tested twice. The visual references are clear enough to keep on a tablet at the bench, and the younger lads stopped asking me the same questions every morning.',
  },
]
